import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

type QueryParams = Record<string, string>;

export function useQueryParams(): QueryParams {
    const [searchParams] = useSearchParams();

    return useMemo(() => {
        const params: QueryParams = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        return params;
    }, [searchParams]);
}

export default useQueryParams;
